import { Subject } from 'rxjs';

class ConsumerInput {
    asset$ = new Subject();
    config$ = new Subject();
}

export default ConsumerInput;
